module.exports = __webpack_public_path__ + "9e546d5c21b56c7d8711c9d038c4be4a.svg";